<template>
    <div>
        <template v-if="my_attendance !== null" >
            <!--Sent to Checker Modal -->
            <div class="modal fade" id="attendacnepopup" tabindex="-1" role="dialog" aria-labelledby="attendacnepopupLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                        </button>
                        <form @submit.prevent="attendanceCorrectionForm()" id="correction" enctype="multipart/form-data">
                            <div class="modal-body employee-attendance-calendar p-4">
                                <div class="popup-head line-head">
                                    <h2 class="pb-2 mb-4"> Attendance Correction <span :class="`float-right attendance-status ${classField}`"> {{form.titleField}} </span> </h2>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Date: </label>
                                    <input type="text" class="form-control" name="" v-model="form.dateField" disabled="" />
                                </div>
                                <!-- <div class="form-group">
                                    <label class="label block-label"> Line Manager: </label>
                                    <input type="text" class="form-control" name="" v-model="team_manager" disabled="" />
                                </div> -->
                                <div class="form-group">
                                        <label class="label block-label"> CC (Email Addresses): </label>
                                        <div class="form-control selecttize-email" id="select_email" >
                                            <input type="text" id="select-symptom" name="cc_emails[]" v-model="form.cc_emails" placeholder="Enter Name or email">
                                        </div>
                                        <!-- <select v-model="form.cc_emails" data-live-search="true" name="cc_emails[]" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('cc_emails') }" multiple>
                                            <option v-for="e in my_attendance.cc_emails" :key="e.id">{{e.email}}</option>
                                        </select> -->
                                        <has-error :form="form" field="cc_emails"></has-error>
                                    </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label class="label block-label"> Time In: </label>
                                            <vue-timepicker format="hh:mm A" input-class="form-control" ref="timePickerIn" placeholder="Time In" v-model="form.timein" name="timein" ></vue-timepicker>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="label block-label"> Time Out: </label>
                                            <vue-timepicker format="hh:mm A" input-class="form-control" ref="timePickerOut" placeholder="Time Out" v-model="form.timeout" name="timeout"></vue-timepicker>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Message: <em class="required">*</em></label>
                                    <textarea class="form-control" name="message" v-model="form.message" :class="{ 'is-invalid': form.errors.has('message') }"></textarea>
                                    <has-error :form="form" field="message"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> Attachment: </label>
                                    <input type="file" name="file" v-on:change="onImageChange"/>
                                </div>
                                <div class="btn-holder text-right">
                                    <button class="btn btn-primary" type="submit" :disabled="busy"> Submit </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div> <!-- Add Category End-->
            <div class="">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> My Attendance </h1>
                </div>
                <div class="row mb-3 top-widgets-row">
                    <div class="col-md-3 widgets-col">
                        <div class="payroll-counter-box attendance-counter-box">
                            <div class="top-box no-bg">
                                <span class="title" title="7"> <em class="rollover"> {{my_attendance.averageAttendance}}% </em> </span>
                                <p> Average Attendance </p>
                            </div>
                            <div class="foot-box"></div>
                        </div>
                    </div>
                    <div class="col-md-3 widgets-col">
                        <div class="payroll-counter-box attendance-counter-box">
                            <div class="top-box no-bg" v-if="my_attendance.averageTimeIn_time">
                                <span class="title txt-pink" title="7"> <em class="rollover"> {{my_attendance.averageTimeIn_time}}</em><span class="time-unit">{{my_attendance.averageTimeIn_ampm}}</span> </span>
                                <p> Average Arrivals </p>
                            </div>
                            <div class="top-box no-bg" v-else>
                                <span class="title txt-pink" title="7"> <em class="rollover"> 00:00</em><span class="time-unit"></span> </span>
                                <p> Average Arrivals </p>
                            </div>
                            <div class="foot-box"></div>
                        </div>
                    </div>
                    <div class="col-md-3 widgets-col">
                        <div class="payroll-counter-box attendance-counter-box">
                            <div class="top-box no-bg">
                                <span class="title" title="7"> <em class="rollover"> {{my_attendance.averageHours}} </em> </span>
                                <p> Average Hours / Day </p>
                            </div>
                            <div class="foot-box"></div>
                        </div>
                    </div>
                    <div class="col-md-3 widgets-col">
                        <div class="payroll-counter-box attendance-counter-box">
                            <div class="top-box no-bg p-0 attendance-top-box">
                                <div class="graph_title">
                                    <b>Attendance Breakdown</b>
                                </div>
                                <div id="graph_sm_attendance_breakdown" style="height:105px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="attendance-calendar-main">
                    <div class="calendar-head clearfix">
                        <h2 class="float-left"> {{my_attendance.monthName}} {{my_attendance.year}} </h2>
                        <div class="calendar-filter float-right mb-4">
                            <div class="row normal-ib-space">
                                <div class="col">
                                    <select class="selectpicker custom-select2" v-model="filterData.selected_year">
                                        <option v-for="year in years" :value="year" :selected="year == my_attendance.year ? 'selected': '' ">{{ year }}</option>
                                    </select>
                                </div>
                                <div class="col">
                                    <select class="selectpicker custom-select2" v-model="filterData.selected_month">
                                        <option value="01" :selected="my_attendance.month == 1 ? 'selected' : '' ">January</option>
                                        <option value="02" :selected="my_attendance.month == 2 ? 'selected' : '' ">February</option>
                                        <option value="03" :selected="my_attendance.month == 3 ? 'selected' : '' ">March</option>
                                        <option value="04" :selected="my_attendance.month == 4 ? 'selected' : '' ">April</option>
                                        <option value="05" :selected="my_attendance.month == 5 ? 'selected' : '' ">May</option>
                                        <option value="06" :selected="my_attendance.month == 6 ? 'selected' : '' ">June</option>
                                        <option value="07" :selected="my_attendance.month == 7 ? 'selected' : '' ">July</option>
                                        <option value="08" :selected="my_attendance.month == 8 ? 'selected' : '' ">August</option>
                                        <option value="09" :selected="my_attendance.month == 9 ? 'selected' : '' ">September</option>
                                        <option value="10" :selected="my_attendance.month == 10 ? 'selected' : '' ">October</option>
                                        <option value="11" :selected="my_attendance.month == 11 ? 'selected' : '' ">November</option>
                                        <option value="12" :selected="my_attendance.month == 12 ? 'selected' : '' ">December</option>
                                    </select>

                                </div>
                                <div class="col">
                                    <button class="btn btn-primary" @click="filterAttendance()"> Select </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="calendar"></div>
                </div>
            </div>
        </template>
        <template v-else-if="my_attendance === null">
            <preLoader></preLoader>
        </template>
    </div>
</template>

<script>
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker';
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css';

export default {
    components: {
            VueTimepicker
        },
    data() {
        return {
            busy: false,
            viewPage : null,
            my_attendance : null,
            updatedEvents: [],
            classField: null,
            team_manager:[],
            form: new Form({
                titleField: null,
                trueDate : null,
                dateField: null,
                line_manager: [],
                cc_emails: [],
                timein: null,
                timeout: null,
                message: null,
                avatar: null
            }),
            filterData: new Form({
                selected_year: null,
                selected_month: null
            }),
            options:[],
        }
    },
    computed : {
        years () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 2017}, (value, index) => 2018 + index)
        }
    },
    mounted() {
        this.currentYear = moment().format('Y');
        this.$Progress.start();
        this.getData();
    },

    methods: {

        filterAttendance(){
            let that = this;
            this.$Progress.start();
                this.filterData.post('api/myAttendance')
               .then(res => {
                    this.my_attendance = [];
                    this.team_manager = [];
                    this.form.line_manager = [];
                    this.my_attendance = res.data;
                    // var tm = res.data.line_managers;
                    // if(tm.length > 0){
                    //     tm.forEach(e => {
                    //         this.form.line_manager.push(e.id);
                    //         this.team_manager.push(e.name);
                    //     });
                    // }else{
                    //     this.form.line_manager = this.team_manager = '--';
                    // }
                    var obj = res.data.monthEvents;
                    var updatedEvents = [];
                    //Making Events
                    _.forEach(obj, function(e, i){
                        if(e.title == 'Attendance Correction' || e.title == 'Absent' || e.title == 'Holiday' || e.title == 'Leave'){
                            updatedEvents.push({
                                title : e.title,
                                start : e.start,
                                className : e.className
                            });
                        }else{
                            updatedEvents.push({
                                title : e.title,
                                start : e.start,
                                className : e.className
                            });
                            updatedEvents.push({
                                title : 'Time In: '+ e.timeIn,
                                start : e.start,
                                className : e.className
                            });
                            updatedEvents.push({
                                title : 'Time Out: '+ e.timeOut,
                                start : e.start,
                                className : e.className
                            });
                        }
                    });
                    $('#calendar').fullCalendar('removeEvents');
                    $('#calendar').fullCalendar('addEventSource',updatedEvents);
                    $('#calendar').fullCalendar('gotoDate',moment(res.data.year+'-'+res.data.month+'-1'));
                    this.$Progress.finish();
                }).then(res => {
                    this.fullCalendar();
                    this.highChart();
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                }).catch(err => {
                    console.log(err);
                });
        },

        getData(){
            let that = this;
            axios.get('/api/myAttendance')
            .then(res => {
                this.my_attendance = res.data;
                this.filterData.selected_year = res.data.year;
                this.filterData.selected_month = res.data.month;
                // var tm = res.data.line_managers;
                // if(tm.length > 0){
                //     tm.forEach(e => {
                //         this.form.line_manager.push(e.id);
                //         this.team_manager.push(e.name);
                //     });
                // }else{
                //     this.form.line_manager = this.team_manager = '--';
                // }
                // USING LODASH
                var obj = res.data.monthEvents;
                _.forEach(obj, function(e, i){
                    if(e.title == 'Attendance Correction' || e.title == 'Absent' || e.title == 'Holiday' || e.title == 'Leave'){
                        that.updatedEvents.push({
                            title : e.title,
                            start : e.start,
                            className : e.className
                        });
                    }else{
                        that.updatedEvents.push({
                            title : e.title,
                            start : e.start,
                            className : e.className
                        });
                        that.updatedEvents.push({
                            title : 'Time In: '+e.timeIn,
                            start : e.start,
                            className : e.className
                        });
                        that.updatedEvents.push({
                            title : 'Time Out: '+ e.timeOut,
                            start : e.start,
                            className : e.className
                        });
                    }
                });
                var cc_emails = res.data.cc_emails;
                cc_emails.forEach(e => {
                    var obj = {id: e.email, type: 'hand', symptom: e.name+ ' - ' + e.email}
                    this.options.push(obj);
                });
                this.$Progress.finish();
            }).then(res => {
                this.fullCalendar();
                this.highChart();
                this.selectizeMethod();
                $(this.$el).find('.selectpicker').selectpicker('refresh');
            }).catch(err => {
                console.log(err);
            });
        },

        clearForm(){
            this.form.avatar = '';
            this.form.message= null;
            this.form.cc_emails = [];
            this.form.timein = null;
            this.form.timeout = null;
        },

        onImageChange(e){
            this.form.avatar = e.target.files[0];
        },

        attendanceCorrectionForm(){
            this.busy = true;
            if((this.form.timein == null && this.form.timeout == null) || this.form.message == null){
                this.showAlertBox('error','Please fill form values first.');
                this.busy = false;
                return false;
            }
            this.$Progress.start();
            //formData config for file Upload
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            let rawData = {
                titleField: this.form.titleField,
                trueDate : this.form.trueDate,
                dateField: this.form.dateField,
                // line_manager: this.form.line_manager,
                cc_emails: this.form.cc_emails,
                timein: this.form.timein,
                timeout: this.form.timeout,
                message: this.form.message,
            }
              //converting into string and the append in FormData
            rawData = JSON.stringify(rawData)
            let formData = new FormData();
            formData.append('file', this.form.avatar);
            formData.append('data', rawData);

            axios.post('api/attendanceCorrectionForm', formData, config)
            .then(res => {
                if(res.status == 200){
                    this.busy = false;
                    this.clearForm();
                    document.getElementById('correction').reset();
                    this.$refs.timePickerIn.clearTime();
                    this.$refs.timePickerOut.clearTime();
                    this.filterAttendance();
                    $("#attendacnepopup").modal('hide');
                    this.showToastBox('success', 'Attendance correction successfully updated');
                    this.$Progress.finish();
                }else{
                    this.busy = false;
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Correction Failed!');
                }

            })
            .catch(err => {
                this.busy = false;
                this.$Progress.fail();
                this.showAlertBox('error', 'Some problem in your form data');
            });
        },

        fullCalendar(){
            let that = this;
            $('#calendar').fullCalendar({
		      header: {
		        left: '',
		        center: '',
		        right: ''
		      },
		      defaultDate: moment(),
		      navLinks: false,
		      editable: false,
		      eventLimit: true,
		      textEscape: true,
		      	  views: {
				     month: {
				       eventLimit: 4
				     }
				},
              events: that.updatedEvents,
              eventClick: function(callEvent, jsEvent, viewObject) {

                    that.form.dateField =callEvent.start.format('dddd DD MMMM YYYY');
                    that.classField = callEvent.className[0];
                    if(that.classField == 'correction') return;
                    that.form.titleField = callEvent.title;
                    that.form.trueDate = callEvent.start.format('YYYY-MM-DD');
                    $("#attendacnepopup").modal('show');
                },

            });
            $('.fc-sun, .fc-sat').each(function(){
                //$(this).append('<a class="fc-day-grid-event fc-h-event fc-event fc-start fc-end holiday"><div class="fc-content"> <span class="fc-title">Holiday</span></div></a>');
            });
        },

        selectizeMethod(){
            let that = this;
            $("#select-symptom").selectize({
                options: that.options,
                optgroups: [
                    { id: 'emails', name: 'Emails'}
                ],
                labelField: 'symptom',
                valueField: 'id',
                optgroupField: 'type',
                optgroupLabelField: 'name',
                optgroupValueField: 'id',
                //  optgroupOrder: ['dental', 'cardiovascular'],
                optgroupOrder: ['left-hand', 'right-hand'],
                searchField: ['symptom'],
                //plugins: ['optgroup_columns'],
                create: false,
                sortField: 'text',
                onChange : function(e){
                    that.form.cc_emails = e;
                }
            });
        },

        highChart(){
            Highcharts.chart('graph_sm_attendance_breakdown', {
                exporting: {
                    enabled: false
                },
                title: {
                    text: ''
                },
                plotOptions: {
                    pie: {
                        size:'150%',
                        innerSize: 45,
                        depth: 0,
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                                enabled: false
                        }
                    },
                    series: {
                        groupPadding: 0
                    }

                },
                credits: false,
                legend: {
                        align: 'right',
                        verticalAlign: 'middle',
                        layout: 'vertical',
                        x: 0,
                        y: 0
                    },
                series: [{
                    type: 'pie',
                    dataLabels: {
                            enabled: false
                    },
                    allowPointSelect: true,

                    data: [{
                            name: 'Present Days',
                            y: this.my_attendance.totalPresentDays,
                            color: '#50ae55'
                        },{
                            name: 'Absent Days',
                            y: this.my_attendance.totalAbsentDays,
                            color: '#eb401f'

                    }],
                    showInLegend: true
                }]
            });
        }
    }
}

</script>
